import { render, staticRenderFns } from "./MapChip.vue?vue&type=template&id=122a4820&"
import script from "./MapChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MapChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122a4820')) {
      api.createRecord('122a4820', component.options)
    } else {
      api.reload('122a4820', component.options)
    }
    module.hot.accept("./MapChip.vue?vue&type=template&id=122a4820&", function () {
      api.rerender('122a4820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/ChipsFilters/MapChip.vue"
export default component.exports